import {
  Button,
  Center,
  Heading,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Text,
} from "@chakra-ui/react";
import { useDynamicModalContext } from "@umami/components";
import { assetsActions, useAppDispatch } from "@umami/state";
import { useEffect, useRef } from "react";

interface OperationSubmittedModalProps {
  onSeeAllOperations: () => void;
}

export const OperationSubmittedModal = ({ onSeeAllOperations }: OperationSubmittedModalProps) => {
  const { onClose } = useDynamicModalContext();
  const dispatch = useAppDispatch();
  const hasRequestedRefetch = useRef(false);

  // an operation was just submitted — bump the refetch trigger so balances,
  // tokens and operations refresh immediately instead of waiting for the next poll.
  // the ref keeps StrictMode's replayed mount effect from firing a second burst
  useEffect(() => {
    if (hasRequestedRefetch.current) {
      return;
    }
    hasRequestedRefetch.current = true;
    dispatch(assetsActions.refetch());
  }, [dispatch]);

  return (
    <ModalContent>
      <ModalHeader>
        <ModalCloseButton />
        <Center flexDirection="column" gap="12px">
          <Heading size="xl">Operation Submitted</Heading>
        </Center>
      </ModalHeader>
      <ModalBody>
        <Text>
          You can follow this operation's progress in the Activity section. It may take up to 30
          seconds to appear.
        </Text>
      </ModalBody>
      <ModalFooter>
        <Button
          width="full"
          onClick={() => {
            onSeeAllOperations();
            onClose();
          }}
          variant="primary"
        >
          See All Operations
        </Button>
      </ModalFooter>
    </ModalContent>
  );
};
